export interface UserDataToken {
  DNI: string;
  Flag_Activo: number;
  IdPerfil: number;
  IdUsuario: number;
  Usuario: string;
  arrOpciones: number[];
  sucursales: Array<{
    IdSucursal: number;
    Nombre: string;
  }>;
}

export const TRANSPORTARE_AUTH = 'transportare-auth';

export interface UserAuth {
  success: boolean;
  token: string;
}

export interface UserData {
  usuario: string;
  password: string;
}
